import React from 'react';
import { reduxForm } from 'redux-form';
import { INCOME_TAX_DECLARATION_RESET_FORM } from 'src/constants/FormNames';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { useTranslation } from 'react-i18next';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import styles from './ResetDeclarationModal.scss';

const PrepareResetDeclarationModal = ({ submitting, submit, isOpen, errors, hideModal }) => {
  const { t } = useTranslation();
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <CommonModal.Header hideModal={hideModal}>{t('features.ReportIncomeTax.show.actions.reset')}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.wrap}>
          <ErrorsSection errors={errors} />
          {t('features.ReportIncomeTax.show.reset_modal.confirm_message')}
          <br />
          {t('features.ReportIncomeTax.show.reset_modal.confirm_warning')}
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.ReportIncomeTax.show.actions.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.ReportIncomeTax.show.actions.reset')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const ResetDeclarationModal = reduxForm({
  form: INCOME_TAX_DECLARATION_RESET_FORM
})(PrepareResetDeclarationModal);

export default ResetDeclarationModal;
